import InfiniteScrollProvider from '../../utils/InfiniteScrollProvider'
import { CursorPaged } from '../../types/definitions'
import { makeObservable } from 'mobx'
import WorkspacePostingOpportunity from './WorkspacePostingOpportunity'
import { ListWorkspacePostingOpportunitiesDelegate } from './WorkspacePostingOpportunityStore'
import { ListWorkspacePostingOpportunitiesQuery } from './dtos/queries'

export default class WorkspacePostingOpportunitiesSearchViewModel {
  scroller = new InfiniteScrollProvider<WorkspacePostingOpportunity>({
    limit: 20,
    // We trigger the initial fetch ourselves. If this was false,
    // we would see 2 initial fetches.
    startFetchTaskAsPending: true,
    fetchItems: (paging, _) => this._fetchWorkspacePostingOpportunities(paging),
  })

  /**
   * Constructor.
   */
  constructor(
    private opportunityFetcher: ListWorkspacePostingOpportunitiesDelegate,
  ) {
    makeObservable(this, {})
  }

  activate() {
    this.scroller.fetch().then()
  }

  /**
   * Fetch opportunities.
   *
   * @param params
   */
  private async _fetchWorkspacePostingOpportunities(
    params: ListWorkspacePostingOpportunitiesQuery,
  ) {
    try {
      return await this.opportunityFetcher(params)
    } catch (error) {
      console.error(error)
      return CursorPaged.empty
    }
  }
}
